function DefaultPostSVG({ style, ...props }) {
    return (
        <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g id="icon">
                <mask
                    id="mask0_3107_2222"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="5"
                    y="2"
                    width="20"
                    height="26"
                >
                    <path
                        id="icon/action/description_24px"
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16.4625 2.5C17.125 2.5 17.7625 2.7625 18.2375 3.2375L24.2625 9.275C24.7375 9.7375 25 10.375 25 11.0375V25C25 26.375 23.875 27.5 22.5 27.5H7.4875C6.1125 27.5 5 26.375 5 25V5C5 3.625 6.125 2.5 7.5 2.5H16.4625ZM11.25 22.5H18.75C19.4375 22.5 20 21.9375 20 21.25C20 20.5625 19.4375 20 18.75 20H11.25C10.5625 20 10 20.5625 10 21.25C10 21.9375 10.5625 22.5 11.25 22.5ZM18.75 17.5H11.25C10.5625 17.5 10 16.9375 10 16.25C10 15.5625 10.5625 15 11.25 15H18.75C19.4375 15 20 15.5625 20 16.25C20 16.9375 19.4375 17.5 18.75 17.5ZM16.25 4.375V10C16.25 10.6875 16.8125 11.25 17.5 11.25H23.125L16.25 4.375Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask0_3107_2222)">
                    <g id="&#226;&#134;&#179; Color">
                        <rect
                            id="Rectangle"
                            width="30"
                            height="30"
                            fill="#878787"
                            style={style}
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default DefaultPostSVG;
